export default __webpack_public_path__ + "f570b48fdfe71dee522f5b98f0cd5640.svg";